import React, { useState } from 'react';

const RequestRepair = () => {

  const [email, setEmail] = useState(""); 
  const [company, setCompany] = useState("");
  const [tel, setTel] = useState("");
  const [breturn, setbReturn ] = useState(false);
  const [repair, setRepair] = useState(false);

  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      
      console.log(email, company, message);

      fetch('https://mucksucker.com:3001/api/sendrepair', {
        method: 'post',
        headers: {'Content-Type':'application/json'},
        body: JSON.stringify({
          from: "my@email.com",  
          email,
          company,
          tel,
          breturn,
          repair,
          message
        })
       });

      alert("Email sent!");
    } catch(err) {
      alert(err);
    }
  };

  function toggleRepair(bIschecked)
  {
    console.log(bIschecked);
    setbReturn(false);
    setRepair(bIschecked);

  }
  function toggleReturn(bIschecked)
  {
    console.log(bIschecked);
    setRepair(false);
    setbReturn(bIschecked);
  }
    return (
      <div className="center">
        <h1>Repairs & Returns</h1>
        <div className="container">

          <form onSubmit={handleSubmit}>

            <input
              type="text"
              placeholder="Company"
              value={company}
              onChange={(e) => setCompany(e.target.value)}  
            />

            <input 
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}  
            />

            <input
              type="tel"
              placeholder="Tel"
              value={tel}
              onChange={(e) => setTel(e.target.value)}  
            />
            <div className='checkBoxContainer'>
                <div>
                    <input
                    type="checkbox"
                    id="repair"
                    name="repair"
                    onChange={(e) => toggleRepair(e.target.checked)}
                    checked ={repair} />
                    <label for="repair">Repair</label>
                </div>

                <div>
                    <input
                    type="checkbox"
                    id="retun"
                    name="return"
                    onChange={(e) => toggleReturn(e.target.checked)}
                    checked ={breturn}  />
                    <label for="retun">Return</label>
                </div>


                
            </div>
            <textarea 
              rows="3"
              placeholder="Details"
              value={message}
              onChange={(e) => setMessage(e.target.value)}  
            ></textarea>
            <button type="submit">Send Email</button>
          </form>


        </div>

      </div>
    )
  };
  
  export default RequestRepair;